import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "section content-container" }
const _hoisted_2 = { class: "container is-fluid" }
const _hoisted_3 = { class: "island" }
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-right" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = { class: "table is-fullwidth" }
const _hoisted_8 = { class: "has-text-centered" }

import { CHANGE_WORKSPACE, HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { onBeforeMount, ref } from 'vue';
import { workspacesApi } from '@/workspaces/workspaces';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { store } from '@/store';
import CreateWorkspaceModal from '@/features/platformAdmin/workspaces/CreateWorkspaceModal.vue';
import NButton from '@shared/designsystem/components/control/button/button.vue';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatformAdminListWorkspaces',
  setup(__props) {

const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);
const workspaces = ref<WorkspaceViewModel[]>([]);
const isLoading = ref(false);
const showCreateModal = ref(false);

onBeforeMount(async () => {
  await loadWorkspaces();
});

async function loadWorkspaces() {
  isLoading.value = true;
  showCreateModal.value = false;

  try {
    workspaces.value = await workspacesApi.loadAll(true);
  } catch (err: any) {
    await handleSeriousError(err.message);
  } finally {
    isLoading.value = false;
  }
}

async function accessTenant(workspace: WorkspaceViewModel) {
  await store.dispatch(CHANGE_WORKSPACE, workspace);
  await router.push({ name: 'root' });
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "level-left" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createVNode(NButton, {
                  variant: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal.value = true))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Create Workspace", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Name"),
                _createElementVNode("th", null, " "),
                _createElementVNode("th", {
                  class: "has-text-centered",
                  style: {"width":"150px"}
                }, "Access Tenant")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (workspace) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: workspace.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'platform-admin-workspace-edit', params: { id: workspace.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(workspace.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, " ", -1)),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(NButton, {
                      icon: "skip-next",
                      variant: "action",
                      onClick: ($event: any) => (accessTenant(workspace))
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    (showCreateModal.value)
      ? (_openBlock(), _createBlock(CreateWorkspaceModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showCreateModal.value = false)),
          onWorkspaceCreated: loadWorkspaces
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})